export default {
  base: {
    fontSize: '13px',
    color: 'hsl(0, 0%, 58%)',
    marginTop: '5px',
    maxWidth: '400px'
  }
};